import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class Step922045Meta extends BaseModel {
  hasFuneralPreArrangement?: boolean;
  hasCemeteryProperty?: boolean;
  hasLastWishesChanges?: boolean;

  constructor(model: Partial<Step922045Meta> = {}) {
    super();

    this.hasFuneralPreArrangement = model.hasFuneralPreArrangement ?? false;
    this.hasCemeteryProperty = model.hasCemeteryProperty ?? false;
    this.hasLastWishesChanges = model.hasLastWishesChanges ?? false;
  }
}
